import Vue from 'vue'
import Router from 'vue-router'
import store from '../store'
import Layout from '../layout/index.vue'
import { getDefaultAccessiblePath, hasRoutePermission } from '../utils/permissionRoute'

Vue.use(Router)

const RouteView = {
  name: 'RouteView',
  render(h) {
    return h('router-view')
  }
}

export const routes = [
  {
    path: '/login',
    component: () => import('../views/login/index.vue'),
    meta: { public: true, title: '登录' }
  },
  {
    path: '/',
    component: Layout,
    redirect: () => getDefaultAccessiblePath(routes, store.getters.permissionCodes) || '/login',
    children: [
      {
        path: 'dashboard',
        component: () => import('../views/dashboard/index.vue'),
        meta: {
          title: '工作台',
          permission: 'dashboard:view',
          permissions: ['audit_center:view'],
          icon: 'el-icon-s-home',
          affix: true
        }
      },
      {
        path: 'profile',
        component: () => import('../views/profile/index.vue'),
        meta: { title: '个人中心', hidden: true }
      },
      {
        path: 'layout-settings',
        component: () => import('../views/layout-settings/index.vue'),
        meta: { title: '布局设置', hidden: true }
      },
      {
        path: 'lock-screen',
        component: () => import('../views/lock-screen/index.vue'),
        meta: { title: '锁定屏幕', hidden: true }
      },
      {
        path: 'admin/users',
        component: () => import('../views/admin/users/index.vue'),
        meta: { title: '管理员管理', permission: 'admin_user:view', icon: 'el-icon-user-solid' }
      },
      {
        path: 'admin/roles',
        component: () => import('../views/admin/roles/index.vue'),
        meta: { title: '角色管理', permission: 'admin_role:view', icon: 'el-icon-s-check' }
      },
      {
        path: 'admin/permissions',
        component: () => import('../views/admin/permissions/index.vue'),
        meta: { title: '权限配置', permission: 'admin_permission:view', icon: 'el-icon-menu' }
      },
      {
        path: 'audits',
        component: () => import('../views/audits/index.vue'),
        meta: { title: '审核中心', permission: 'audit_center:view', icon: 'el-icon-document-checked' }
      },
      {
        path: 'casting-hall',
        component: () => import('../views/platform/casting-hall/index.vue'),
        meta: { title: '通告大厅', permission: 'casting_notice_audit:view', icon: 'el-icon-office-building' }
      },
      {
        path: 'artist-users',
        component: () => import('../views/platform/artist-users/index.vue'),
        meta: { title: '艺人用户', permission: 'artist_profile_audit:view', icon: 'el-icon-user' }
      },
      {
        path: 'merchant-users',
        component: () => import('../views/platform/merchant-users/index.vue'),
        meta: { title: '商家用户', permission: 'merchant_auth_audit:view', icon: 'el-icon-s-shop' }
      },
      {
        path: 'platform/orders',
        component: RouteView,
        redirect: '/platform/orders/list',
        meta: { title: '订单管理', permission: 'platform_order:view', icon: 'el-icon-document-copy' },
        children: [
          {
            path: 'list',
            component: () => import('../views/platform/orders/index.vue'),
            meta: { title: '订单列表', permission: 'platform_order:view' }
          },
          {
            path: 'commission-rules',
            component: () => import('../views/platform/order-commission/index.vue'),
            meta: { title: '订单抽成配置', permission: 'platform_order:view' }
          }
        ]
      },
      {
        path: 'platform/private-messages',
        component: () => import('@/views/platform/private-messages/index.vue'),
        meta: { title: '私信管理', permission: 'platform_private_message:view', icon: 'el-icon-chat-dot-round' }
      },
      {
        path: 'platform/finance',
        component: RouteView,
        redirect: '/platform/finance/transactions',
        meta: { title: '财务管理', permission: 'platform_finance:view', icon: 'el-icon-s-finance' },
        children: [
          {
            path: 'transactions',
            component: () => import('@/views/platform/finance-transactions/index.vue'),
            meta: { title: '财务流水', permission: 'platform_finance:view' }
          }
        ]
      },
      {
        path: 'platform/customer-service',
        component: () => import('@/views/platform/customer-service/index.vue'),
        meta: { title: '客服中心', permission: 'customer_service_center:view', icon: 'el-icon-phone-outline' }
      },
      {
        path: 'platform/membership',
        component: () => import('@/views/platform/membership/index.vue'),
        meta: { title: '会员管理中心', permission: 'platform_membership:view', icon: 'el-icon-medal' }
      },
      {
        path: 'platform/distribution',
        component: () => import('@/views/platform/distribution/index.vue'),
        meta: { title: '分销中心', permission: 'distribution:view', icon: 'el-icon-share' }
      },
      {
        path: 'platform/notice-exposure',
        component: () => import('@/views/platform/notice-exposure/index.vue'),
        meta: { title: '通告曝光配置', permission: 'platform_membership:view', icon: 'el-icon-s-marketing' }
      },
      {
        path: 'ops',
        component: RouteView,
        redirect: '/ops/taxonomies',
        meta: { title: '运营管理', permission: 'ops_taxonomy:view', icon: 'el-icon-s-operation' },
        children: [
          {
            path: 'taxonomies',
            component: () => import('../views/ops/taxonomies/index.vue'),
            meta: { title: '分类标签管理', permission: 'ops_taxonomy:view' }
          },
          {
            path: 'delivery',
            component: RouteView,
            redirect: '/ops/delivery/banners',
            meta: { title: '投放管理', permission: 'ops_taxonomy:view' },
            children: [
              {
                path: 'banners',
                component: () => import('../views/ops/banners/index.vue'),
                meta: { title: '轮播广告管理', permission: 'ops_resource_item:view' }
              },
              {
                path: 'resource-items',
                component: () => import('../views/ops/resource-items/index.vue'),
                meta: { title: '投放项管理', permission: 'ops_taxonomy:view' }
              },
              {
                path: 'resource-positions',
                component: () => import('../views/ops/resource-positions/index.vue'),
                meta: { title: '资源位定义管理', permission: 'ops_resource_position:view' }
              }
            ]
          },
          {
            path: 'message-center',
            component: () => import('../views/ops/message-center/index.vue'),
            meta: { title: '消息中心', permission: 'ops_message_center:view' }
          },
          {
            path: 'message-send',
            component: () => import('../views/ops/message-send/index.vue'),
            meta: { title: '系统通知发送', permission: 'ops_message_task:create' }
          },
          {
            path: 'message-tasks',
            component: () => import('../views/ops/message-tasks/index.vue'),
            meta: { title: '发送任务记录', permission: 'ops_message_task:view' }
          },
          {
            path: 'message-tasks/:id',
            component: () => import('../views/ops/message-tasks/detail.vue'),
            meta: { title: '任务详情', permission: 'ops_message_task:detail', hidden: true }
          }
        ]
      },
      {
        path: 'audits/merchant-auth/:id',
        component: () => import('../views/audits/merchant-auth-detail.vue'),
        meta: { title: '商家认证审核详情', permission: 'merchant_auth_audit:view', hidden: true }
      },
      {
        path: 'audits/artist-realname/:id',
        component: () => import('../views/audits/artist-realname-detail.vue'),
        meta: { title: '艺人实名审核详情', permission: 'artist_realname_audit:view', hidden: true }
      },
      {
        path: 'audits/artist-profile/:id',
        component: () => import('../views/audits/artist-profile-detail.vue'),
        meta: { title: '艺人资料审核详情', permission: 'artist_profile_audit:view', hidden: true }
      },
      {
        path: 'audits/artist-star-profile/:id',
        component: () => import('../views/audits/artist-star-profile-detail.vue'),
        meta: { title: '星途档案审核详情', permission: 'artist_profile_audit:view', hidden: true }
      },
      {
        path: 'audits/casting-notice/:id',
        component: () => import('../views/audits/casting-notice-detail.vue'),
        meta: { title: '通告详情', permission: 'casting_notice_audit:view', hidden: true }
      }
    ]
  }
]

const hiddenMenuPaths = ['/ops/delivery/resource-items', '/ops/delivery/resource-positions']

function normalizeMenuPath(parentPath, routePath) {
  if (!routePath) {
    return parentPath || '/'
  }
  if (routePath.startsWith('/')) {
    return routePath
  }
  return `${parentPath || ''}/${routePath}`.replace(/\/+/g, '/')
}

function applyHiddenMenuMeta(routeList, parentPath = '') {
  ;(routeList || []).forEach(route => {
    const currentPath = normalizeMenuPath(parentPath, route.path)
    if (hiddenMenuPaths.includes(currentPath)) {
      route.meta = Object.assign({}, route.meta, { hidden: true })
    }
    if (Array.isArray(route.children) && route.children.length) {
      applyHiddenMenuMeta(route.children, currentPath)
    }
  })
}

applyHiddenMenuMeta(routes)

const router = new Router({
  mode: 'hash',
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta.public) {
    next()
    return
  }
  if (!store.getters.isLoggedIn) {
    next('/login')
    return
  }
  if (!store.state.adminInfo) {
    try {
      await store.dispatch('refreshMe')
    } catch (e) {
      next('/login')
      return
    }
  }
  let permissionCodes = store.getters.permissionCodes
  let defaultPath = getDefaultAccessiblePath(routes, permissionCodes)
  if (!hasRoutePermission(to, permissionCodes)) {
    try {
      await store.dispatch('refreshMe')
      permissionCodes = store.getters.permissionCodes
      defaultPath = getDefaultAccessiblePath(routes, permissionCodes)
    } catch (e) {
      next('/login')
      return
    }
    if (!hasRoutePermission(to, permissionCodes)) {
      next(defaultPath || '/login')
      return
    }
  }
  if (to.path === '/' && defaultPath) {
    next(defaultPath)
    return
  }
  next()
})

router.afterEach(to => {
  if (!to.meta.public) {
    store.dispatch('addVisitedView', to)
  }
})

export default router

